// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_eh-0";
export var actionModalContentContainer = "_eh-1";
export var createTagButton = "_eh-2";
export var footerContainer = "_eh-7";
export var fullWidthDivider = "_eh-3";
export var hasCreateTagButton = "_eh-4";
export var noCreateTagButton = "_eh-5";
export var tagsContainer = "_eh-6";
export var tagsModalContentContainer = "_eh-8";